module.exports = {"450331100":"荔城镇","450331101":"东昌镇","450331102":"新坪镇","450331103":"杜莫镇","450331104":"青山镇","450331105":"修仁镇","450331106":"大塘镇","450331107":"花箦镇","450331108":"双江镇","450331109":"马岭镇","450331200":"龙怀乡","450331201":"茶城乡","450331202":"蒲芦瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450331.json
// module id = 1933
// module chunks = 0